import React, { useState } from "react";
import "./AdminPackage.css";
import Skeleton from "react-loading-skeleton";

function DetailsSkeleton(props) {
  return (
    <div className="sidePanelWrap viewDetails_panelV2">
      <div className="sidePanelTopSection">
        <div className="makeFlex spaceBetween hrtlCenter appendBottom20 ">
          <div className="viewDetailsHeading cursorPointer">
            <span
              id="hotelBackArrow"
              className="overlaySprite backArrowBlue backIcon appendTop3"
            > <Skeleton /></span>
            <span className="font20 blackText latoBlack viewDetailText" >
              <Skeleton />
            </span>
          </div>
        </div>
      </div>
      <div className="htDetails" id="hotelDetailTop">
        <div className="makeFlex hrtlCenter">
          <h3 className="font18 latoBlack appendBottom2 lineHeight22 false">
            <Skeleton />
          </h3>
          <div className="starRatng">
            <span className="hotelRating rating_blank">
              <Skeleton />
            </span>
          </div>
          <div className="imgWrap0">
            <Skeleton />
          </div>
        </div>
        <p className="latoBold font11 greyText lineHeight14">
          <Skeleton />
        </p>
        <div className="latoBold font11 greyText lineHeight14 appendBottom15"></div>
        <div className="makeFlex appendBottom10">
          <div className="readAllReviews"></div>
        </div>
        <div className="makeFlex appendBottom10 grid-five">
          <div className="imgWrap1">

            <div className="GalleryHeader">
              <div className="GalleryImg">
                <div className="GalleryBig_img">
                  <Skeleton />
                </div>
                <div className="GallerySmall_img">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="GallerySmallerSection"
                      style={{ paddingRight: 5, paddingBottom: 5 }}
                    >
                      <Skeleton />
                    </div>
                    <div
                      className="GallerySmallerSection"
                      style={{ paddingRight: 5, paddingTop: 5 }}
                    >
                      <Skeleton />
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="GallerySmallerSection"
                      style={{ paddingLeft: 5, paddingBottom: 5 }}
                    >
                      <Skeleton />
                    </div>
                    <div
                      className="GallerySmallerSection"
                      style={{ paddingLeft: 5, paddingTop: 5 }}
                    >
                      <Skeleton />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="_navSticky navSticky appendBottom15">
        <ul id="hotel_trip_tab" className=" hotel tripTab" style={{ marginTop: '43%' }}>
          <li id="About_the_hotel_0" className="">
            <Skeleton />
          </li>
          <li id="Rooms_1" className="">
            <Skeleton />
          </li>
          <li id="Facilities_2" className="">
            <Skeleton />
          </li>
          <li id="Location_3" className="">
            <Skeleton />
          </li>
        </ul>
      </div>
      <div className="scrollMargin130" id="About_the_hotel">
        <Skeleton />
      </div>
      <div className="viewDetailsWrapper scrollMargin130">
        <Skeleton />
      </div>
    </div>
  );
}

export default DetailsSkeleton;
